// src/components/Profile/ProfileSwipeCard.jsx
import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import './ProfileSwipeCard.css';

const ProfileSwipeCard = ({ profile = {} }) => {
  const {
    locationPreference = '—',
    yearsOfExperience = '0',
    locumExperience = '0',
    availability = {},
    certifications = [],
    stateLicenses = [],
    desiredHourlyRates = [],
    preferredCareModel = '—',
    areasOfSpecialty = [],
    caseTypes = [],
    regionalAnesthesiaProficiency = [],
    emrExperience = [],
    preferredSettings = [],
    traumaCenterLevel = [],
  } = profile;

  const firstRate = desiredHourlyRates[0] || 'N/A';
  const scheduleTags = Array.isArray(availability.desiredSchedule) ? availability.desiredSchedule : [];
  const contractTags = Array.isArray(availability.contractType) ? availability.contractType : [];
  const availabilityDate = availability.availabilityDate || 'N/A';

  return (
    <div className="profile-swipe-card-wrapper">
      <Card className="profile-swipe-card">
        <Card.Body className="card-body-flex">
          {/* HEADER */}
          <div className="header-row">
            <h5 className="card-title">
              {locationPreference} · {yearsOfExperience}+ yrs · {firstRate}/hr
            </h5>
          </div>

          {/* AVAILABILITY BADGES */}
          <div className="badge-row">
            {scheduleTags.length > 0
              ? scheduleTags.map((tag, i) => (
                  <Badge key={`sch-${i}`} bg="info" className="badge-pill">
                    {tag}
                  </Badge>
                ))
              : (
                  <Badge bg="secondary" className="badge-pill">
                    Schedule: N/A
                  </Badge>
                )}

            {availabilityDate !== 'N/A' && (
              <Badge bg="light" text="dark" className="badge-pill">
                Start: {availabilityDate}
              </Badge>
            )}

            {contractTags.map((tag, i) => (
              <Badge key={`ctr-${i}`} bg="secondary" className="badge-pill">
                {tag}
              </Badge>
            ))}
          </div>

          {/* SUMMARY */}
          <div className="summary-text">
            <p><strong>Care Model:</strong> {preferredCareModel}</p>
            <p><strong>Licenses:</strong> {stateLicenses.join(', ') || 'N/A'}</p>
            <p><strong>Specialties:</strong> {areasOfSpecialty.join(', ') || 'N/A'}</p>
          </div>

          {/* DETAILS */}
          <div className="detail-section">
            <h6>Experience</h6>
            <ul>
              <li>{yearsOfExperience}+ years</li>
              <li>Locum: {locumExperience}</li>
            </ul>
          </div>

          <div className="detail-section">
            <h6>Case Types</h6>
            {caseTypes.length > 0 ? (
              <div className="detail-badges">
                {caseTypes.map((t, i) => (
                  <Badge key={i} bg="light" text="dark" className="detail-badge">
                    {t}
                  </Badge>
                ))}
              </div>
            ) : (
              <p className="empty-text">None specified</p>
            )}
          </div>

          <div className="detail-section">
            <h6>Regional Proficiency</h6>
            {regionalAnesthesiaProficiency.length > 0 ? (
              <div className="detail-badges">
                {regionalAnesthesiaProficiency.map((b, i) => (
                  <Badge key={i} bg="info" className="detail-badge">
                    {b}
                  </Badge>
                ))}
              </div>
            ) : (
              <p className="empty-text">None specified</p>
            )}
          </div>

          <div className="detail-section">
            <h6>EMR Systems</h6>
            {emrExperience.length > 0 ? (
              <div className="detail-badges">
                {emrExperience.map((e, i) => (
                  <Badge key={i} bg="dark" className="detail-badge">
                    {e}
                  </Badge>
                ))}
              </div>
            ) : (
              <p className="empty-text">None specified</p>
            )}
          </div>

          <div className="detail-section">
            <h6>Facility Preferences</h6>
            <ul>
              <li>Settings: {preferredSettings.join(', ') || 'N/A'}</li>
              <li>Trauma: {traumaCenterLevel.join(', ') || 'N/A'}</li>
            </ul>
          </div>

          <div className="detail-section">
            <h6>Certifications</h6>
            <p>{certifications.join(', ') || 'N/A'}</p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProfileSwipeCard;
